// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__irlik","row":"ProcedureTreatmentSummary_row__1SkzY"};